import { useAuthStore } from '~/domains/auth';

const getTrustedAppOrigins = (): string[] =>
  String(import.meta.env.VITE_TRUSTED_APP_ORIGINS ?? '')
    .split(',')
    .map((origin) => origin.trim())
    .filter((origin) => origin !== '');

const getReferrerOrigin = (): string | null => {
  try {
    return new URL(document.referrer).origin;
  } catch {
    return null;
  }
};

export default (): void => {
  if (document.referrer === '') return;

  const referrerOrigin = getReferrerOrigin();

  if (referrerOrigin === null || referrerOrigin === window.location.origin) {
    return;
  }

  if (!getTrustedAppOrigins().includes(referrerOrigin)) return;

  const authStore = useAuthStore();

  authStore.setRedirectFromExternalDomain(referrerOrigin);
};
